import Link from 'next/link';
import SearchButton from './SearchButton';
import HelpArticleLink from './HelpArticleLink';
import IntegrationsGrid from './IntegrationsGrid';
import Divider from '@mui/material/Divider';

export default function HelpCategory({ category }) {
  const alphabeticalArticles = [...category.articles].sort((a, b) =>
    a.title.localeCompare(b.title),
  );

  return (
    <>
      <div className="tw-flex tw-max-w-screen-lg tw-flex-col tw-py-10 tw-mx-auto tw-w-full tw-px-2.5 lg:tw-px-20">
        <SearchButton />
      </div>
      <div className="tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-800 tw-min-h-[50vh] tw-bg-white/50 dark:tw-bg-black/50 tw-shadow-[inset_10px_-50px_94px_0_rgb(199,199,199,0.2)] dark:tw-shadow-none tw-backdrop-blur-lg">
        <div className="tw-flex tw-flex-col tw-py-10 tw-max-w-screen-lg tw-mx-auto tw-w-full tw-px-2.5 lg:tw-px-20">
          <div className="tw-flex tw-items-center tw-space-x-2">
            <Link
              href="/help"
              className="tw-text-sm tw-font-medium tw-text-gray-500 hover:tw-text-gray-800 dark:hover:tw-text-gray-400"
            >
              Help Center
            </Link>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="tw-h-4 tw-w-4 tw-text-gray-400"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>

            <Link
              href={`/help/category/${category.slug}`}
              className="tw-text-sm tw-font-medium tw-text-gray-500 hover:tw-text-gray-800 dark:hover:tw-text-gray-400"
            >
              {category.title}
            </Link>
          </div>
          <div className="tw-my-8 flex tw-flex-col tw-space-y-4">
            <Link href={`/help/category/${category.slug}`}>
              <h1 className="tw-font-display tw-text-2xl tw-font-bold sm:tw-text-4xl">
                {category.title}
              </h1>
            </Link>
            <p className="tw-text-gray-500">{category.description}</p>
          </div>
          {category.slug === 'integrations' ? (
            <IntegrationsGrid articles={category.articles} />
          ) : (
            <>
              <div className="tw-grid tw-gap-2 tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-800 tw-bg-white dark:tw-bg-gray-800 tw-p-4">
                {category.articles.map(article => {
                  if (
                    article.subcategory !== 'site-builder-widgets' &&
                    article.subcategory !== 'easy-editor-blocks' &&
                    (category.slug !== 'publish' ||
                      article.categories[0] !== 'integrations')
                  )
                    return (
                      <HelpArticleLink key={article.slug} article={article} />
                    );
                })}
              </div>
            </>
          )}
          {category.slug === 'hosting' && (
            <div className="tw-mt-4 tw-grid tw-gap-2 tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-800 tw-bg-white dark:tw-bg-gray-800 tw-p-4">
              <h2
                className="tw-text-2xl tw-font-bold tw-px-2 sm:tw-px-4 -tw-mt-[90px] tw-pt-[90px]"
                id="site-builder-widgets"
              >
                Site Builer Widgets
              </h2>
              <Divider className="tw-mx-2 sm:tw-mx-4" />
              {alphabeticalArticles.map(article => {
                if (article.subcategory)
                  return (
                    <HelpArticleLink key={article.slug} article={article} />
                  );
              })}
            </div>
          )}
          {category.slug === 'publish' && (
            <>
              <div className="tw-mt-4 tw-grid tw-gap-2 tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-800 tw-bg-white dark:tw-bg-gray-800 tw-p-4">
                <h2
                  className="tw-text-2xl tw-font-bold tw-px-2 sm:tw-px-4 -tw-mt-[90px] tw-pt-[90px]"
                  id="easy-editor-blocks"
                >
                  EasyEditor Blocks
                </h2>
                <Divider className="tw-mx-2 sm:tw-mx-4" />
                {alphabeticalArticles.map(article => {
                  if (article.subcategory === 'easy-editor-blocks')
                    return (
                      <HelpArticleLink key={article.slug} article={article} />
                    );
                })}
              </div>
              <div className="tw-mt-4 tw-grid tw-gap-2 tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-800 tw-bg-white dark:tw-bg-gray-800 tw-p-4">
                <h2
                  className="tw-text-2xl tw-font-bold tw-px-2 sm:tw-px-4 -tw-mt-[90px] tw-pt-[90px]"
                  id="supported-embeds"
                >
                  Supported Embeds
                </h2>
                <Divider className="tw-mx-2 sm:tw-mx-4" />
                {alphabeticalArticles.map(article => {
                  if (article.categories[0] === 'integrations')
                    return (
                      <HelpArticleLink key={article.slug} article={article} />
                    );
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
